var _circle, _path, _path2, _path3, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20,
    fill: "#EEFFFC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_254",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 19.5C24.433 19.5 26 17.933 26 16C26 14.067 24.433 12.5 22.5 12.5C20.567 12.5 19 14.067 19 16C19 17.933 20.567 19.5 22.5 19.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 31C12.5 26.5815 16.5295 23 21.5 23",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H31V31H24V26Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 26V24.5C29 24.1022 28.842 23.7206 28.5607 23.4393C28.2794 23.158 27.8978 23 27.5 23C27.1022 23 26.7206 23.158 26.4393 23.4393C26.158 23.7206 26 24.1022 26 24.5V26",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.5H34.5V34.5H10.5V10.5Z",
    fill: "#0FAA8E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalInformation);
export default __webpack_public_path__ + "static/media/personal-information.eee8597b0f43dea2bc0ac1e6ae34ed72.svg";
export { ForwardRef as ReactComponent };